import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ButtonBase, Typography, alpha } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import logo from '../assets/logo.png';
const NAV_ITEMS = [
    {
        key: 'dashboard',
        label: 'Dashboard',
        icon: DashboardRoundedIcon,
        path: '/dashboard',
    },
    {
        key: 'cases',
        label: 'Cases',
        icon: AssignmentRoundedIcon,
        path: '/cases',
    },
    {
        key: 'calendar',
        label: 'Calendar',
        icon: CalendarMonthRoundedIcon,
        path: null,
    },
    {
        key: 'settings',
        label: 'Settings',
        icon: SettingsRoundedIcon,
        path: null,
    },
];
export default function Sidebar() {
    const location = useLocation();
    const navigate = useNavigate();
    return (_jsxs(Box, { sx: {
            width: 272,
            flexShrink: 0,
            height: '100%',
            bgcolor: '#F8FAFB',
            borderRight: '1px solid rgba(15, 23, 42, 0.08)',
            display: 'flex',
            flexDirection: 'column',
        }, children: [_jsx(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    pt: 5,
                    pb: 4,
                }, children: _jsx(Box, { component: "img", src: logo, alt: "Helder", sx: { width: 176, display: 'block', transform: 'translateX(3.35%)' } }, void 0) }, void 0), _jsx(Box, { sx: { mx: 3, borderTop: '1px solid rgba(15, 23, 42, 0.08)' } }, void 0), _jsx(Box, { sx: {
                    px: 3,
                    pt: 4,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1.5,
                }, children: NAV_ITEMS.map(({ key, label, icon: Icon, path }) => {
                    const navigable = path !== null;
                    const selected = navigable &&
                        (location.pathname.startsWith(path) ||
                            (path === '/cases' && location.pathname.startsWith('/case/')));
                    return (_jsxs(ButtonBase, { disableRipple: true, disableTouchRipple: true, onClick: navigable ? () => navigate(path) : undefined, sx: {
                            justifyContent: 'flex-start',
                            alignSelf: 'flex-start',
                            minWidth: 192,
                            gap: 2,
                            px: 2.75,
                            py: 2,
                            borderRadius: '10px',
                            cursor: navigable ? 'pointer' : 'default',
                            transition: 'background-color 0.12s ease, color 0.12s ease',
                            color: selected ? 'primary.main' : '#3F4B5C',
                            bgcolor: selected ? alpha('#0073BC', 0.1) : 'transparent',
                            '&:hover': navigable && !selected
                                ? { bgcolor: 'rgba(15, 23, 42, 0.045)' }
                                : undefined,
                            '&:active': navigable
                                ? {
                                    bgcolor: selected
                                        ? alpha('#0073BC', 0.16)
                                        : 'rgba(15, 23, 42, 0.07)',
                                }
                                : undefined,
                        }, children: [_jsx(Icon, { sx: {
                                    fontSize: 25,
                                    color: selected ? 'primary.main' : '#8996A6',
                                } }, void 0), _jsx(Typography, { sx: {
                                    fontWeight: selected ? 600 : 500,
                                    fontSize: 17,
                                    letterSpacing: 0.1,
                                    whiteSpace: 'nowrap',
                                }, children: label }, void 0)] }, key));
                }) }, void 0)] }, void 0));
}
